import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import StatusCell from "./StatusCell";
import ActionsCell from "./ActionCell";
import UpdateDetailsModal from "./UpdateDetailsModal";

const UpdatedOrdersDataTable = ({ data, refreshData }) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedUpdateId, setSelectedUpdateId] = useState(null);
  const [rejectionReason, setRejectionReason] = useState("");
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedUpdateData, setSelectedUpdateData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  // Add this new function
  const handleShowDetails = (update) => {
    setSelectedUpdateData(update);
    setShowDetailsModal(true);
  };

  const handleActionClick = (updateId, action) => {
    setSelectedUpdateId(updateId);
    setSelectedAction(action);
    setShowConfirmation(true);
  };

  const handleConfirmAction = async () => {
    if (selectedAction === "reject" && !rejectionReason) {
      return;
    }
    setIsLoading(true);
    const { response } = await Helper.Get({
      url: `${api_Routes.Orders.ProcessUpdated}/${selectedUpdateId}/${selectedAction}`,
      hasToken: true,
      data: selectedAction === "reject" ? { reason: rejectionReason } : {},
    });

    if (response) {
      refreshData();
      handleCloseConfirmation();
    }
    setIsLoading(false);
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
    setSelectedAction(null);
    setSelectedUpdateId(null);
    setRejectionReason("");
  };

  return (
    <>
      <TableContainer component={Paper}>
        {/* Existing table code remains the same */}
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow className="bg-primary">
              {[
                "Update ID",
                "Panel",
                "Service Name",
                "User",
                "Status",
                "Actions",
              ].map((header) => (
                <TableCell
                  key={header}
                  align="center"
                  className="!text-darkTextColor"
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((update) => (
              <TableRow key={update.id}>
                <TableCell align="center">{update.id}</TableCell>
                <TableCell align="center">{update.panel}</TableCell>
                <TableCell align="center">{update.service_name}</TableCell>
                <TableCell align="center">
                  {update.user_name || "N/A"}
                </TableCell>
                <StatusCell update={update} />
                <ActionsCell
                  update={update}
                  handleActionClick={handleActionClick}
                  handleShowDetails={handleShowDetails}
                  id={update.id}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={showConfirmation} onClose={handleCloseConfirmation}>
        <DialogTitle>
          Confirm {selectedAction === "approve" ? "Approval" : "Rejection"}
        </DialogTitle>
        <DialogContent>
          {selectedAction === "approve" ? (
            <DialogContentText>
              Are you sure you want to approve this panel update?
            </DialogContentText>
          ) : (
            <>
              <DialogContentText>
                Please provide a reason for rejecting this update:
              </DialogContentText>
              <TextField
                autoFocus
                margin="dense"
                label="Rejection Reason"
                type="text"
                fullWidth
                variant="standard"
                value={rejectionReason}
                onChange={(e) => setRejectionReason(e.target.value)}
                required
              />
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmation}>Cancel</Button>
          <Button
            onClick={handleConfirmAction}
            color={selectedAction === "approve" ? "success" : "error"}
            disabled={selectedAction === "reject" && !rejectionReason}
          >
            {isLoading ? "Loading.." : `Confirm ${selectedAction}`}
          </Button>
        </DialogActions>
      </Dialog>
      {selectedUpdateData && (
        <UpdateDetailsModal
          setShowDetailsModal={setShowDetailsModal}
          showDetailsModal={showDetailsModal}
          selectedUpdateData={selectedUpdateData}
        />
      )}
    </>
  );
};

export default UpdatedOrdersDataTable;
